export default __webpack_public_path__ + "static/media/voucherGTS1.08a5c411.jpg";